module.exports = __webpack_public_path__ + "img/GH-kyujin-work-illustration002.2550ff7f.webp";